import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { Ciudad, CiudadCotizador } from './../models/ciudad';
import { HttpRequestService } from './HttpRequestService';

@Injectable({
  providedIn: 'root',
})
export class CiudadesService {
  constructor(
    private http: HttpClient,
    private httpRequestService: HttpRequestService
  ) { }

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly pedidosEnviaUrl = `${environment.apiEnviaUrl}`;
  private readonly triidyServiceLogistics = `${environment.apiTriidyUrlLogistics}/api`;

  getPaises(): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/GetPaises`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  getCiudades(pais): Observable<Ciudad[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      pais,
      token,
    });
    return this.http
      .get<Ciudad[]>(`${this.triidyServiceUrl}/GetCentroLogistico`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return plainToClass(Ciudad, respuesta);
        })
      );
  }

  getCiudades2(codigo_pais): Observable<CiudadCotizador[]> {
    const params = this.httpRequestService.getHttpParamsRequestParams({
      codigo_pais,
    });
    return this.http
      .get<CiudadCotizador[]>(`${this.triidyServiceLogistics}/CiudadesDestino`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return plainToClass(CiudadCotizador, respuesta);
        })
      );
  }

  getCiudadesmen(nombre_pais): Observable<Ciudad[]> {
    const token = environment.serviceToken;
    // const nombre_pais = atob(sessionStorage.getItem(btoa('countrySelectedName')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
      nombre_pais
    });
    return this.http
      .get<Ciudad[]>(`${this.triidyServiceUrl}/GetCentroLogistico_TriidyEntregas`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return plainToClass(Ciudad, respuesta);
        })
      );
  }
}
